import { Injectable } from '@angular/core';
import { Employee } from '@models/employee/employee.model';

@Injectable()
export class FetchEmployees {
    forCompanyId(companyId: number): Promise<[any[], any]> {
        return Employee.param('company', companyId).where('status', 'active').all();
    }
}
